import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Select, TextField, TextareaAutosize } from '@mui/material';
import { getLinkProdFinal, getZipFromProdutosFinais, insert, saveProdFinalZipInOikos, verificaPastaProdFinal, getProdCoordenadorPfId } from '../../../utils/fc/index.js'
import moment from 'moment';
import JSZip from 'jszip';
import { graphClient } from '../../../store/sagas/auth.js';
import oikosApi from '../../../services/oikos/index.js'
import { Modal, Spinner, ModalBody, ModalHeader } from 'reactstrap';
// import { Document, Page } from 'react-pdf';
// import { pdfjs } from 'react-pdf';
import { useParams } from 'react-router-dom';
//import OneDriveTeste from '../OneDriveTeste/OneDriveTeste';
import {getProdutoFinal, notifyByEmail, criaLinkVisualizacaoProdFinal, getZipAndSaveInOikos} from '../../../utils/fc/index.js';
import { notifyError, notifySuccess } from '../../../utils/notify/index.js'
import ModalErroProdFinalOneDrive from '../ModalErroProdFinalOneDrive/ModalErroProdFinalOneDrive.jsx';


// Text layer for React-PDF.
// import 'react-pdf/dist/Page/TextLayer.css';

// Importing the PDF.js worker.
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(    'pdfjs-dist/build/pdf.worker.min.js',    import.meta.url,).toString();

const ModalFormEntregueAoEp = ( {dataContratual, tecResp, ...props} ) => {

    const [open, setOpen] = useState(false);
    const [obsTec, setObsTec] = useState('');
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const [openModalErro, setOpenModalErro] = useState(false);
    const [files, setFiles] = useState([]);

    const handleClickOpen = async () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeObs = (event) => {
        setObsTec(event.target.value);
    };

    const entregaRevInterna = async () => {
        setIsStatusLoading(true)
        const verificaPastaVazia = await verificaPastaProdFinal(props.produto.prod_drive);
        if (verificaPastaVazia) {
          await getZipAndSaveInOikos(props.produto.prod_drive, props.produto);
          await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 3, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
          await notifyByEmail(props.produto.prod_id, {obs: obsTec})
          /*
          const formData = new FormData()
          formData.append('prod_drive', props.produto.prod_drive)
          formData.append('prod_id', props.produto.prod_id)
          formData.append('prod_desc', props.produto.prod_desc)
          formData.append('table', 'arquivo')
          formData.append('action', 'get_files_upload_zip')
          const fileUploadRes = await oikosApi.post('/', formData)
          console.log('fileUploadRes', fileUploadRes)
          */
          notifySuccess('Produto entregue à revisao!');
          console.log('entregue à revisao');
          setIsStatusLoading(false);
          handleClose();
          props.setCount(prevState => prevState + 1);
        } else {
          setIsStatusLoading(false);
          //setOpenModalErro(!openModalErro);
          handleClose();
        }
    }

    const entregaDiretoGestao = async () => {
      setIsStatusLoading(true);
      const verificaPastaVazia = await verificaPastaProdFinal(props.produto.prod_drive);
      if (verificaPastaVazia) {
        console.log('pasta contém arquivos');
        try {
          await getZipAndSaveInOikos(props.produto.prod_drive, props.produto)
          console.log('passou zip');
          await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
          await notifyByEmail(props.produto.prod_id, {obs: obsTec});
          /*
          const formData = new FormData()
          formData.append('prod_drive', props.produto.prod_drive)
          formData.append('prod_desc', props.produto.prod_desc)
          formData.append('prod_id', props.produto.prod_id)
          formData.append('table', 'arquivo')
          formData.append('action', 'get_files_upload_zip')
          const fileUploadRes = await oikosApi.post('/', formData)
          console.log('fileUploadRes', fileUploadRes)
          */
          notifySuccess('Produto entregue à gestão!');
          setIsStatusLoading(false);
          handleClose();
          props.setCount(prevState => prevState + 1);
        }
        catch (er) {
          console.log(er)
        }
      } else {
        setIsStatusLoading(false);
        //setOpenModalErro(!openModalErro);
        handleClose();
      }
    }

    return (
        <>
            <Button variant="" onClick={handleClickOpen}>
            Entregar ao EP
            </Button>
            {openModalErro && (
                <ModalErroProdFinalOneDrive openModalErro={openModalErro} setOpenModalErro={setOpenModalErro}/>
            )}
            <Dialog
            fullWidth
            maxWidth= 'sm'
            open={open}
            onClose={handleClose}
            PaperProps={{
            component: 'form',
            onSubmit: async (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                console.log(formJson);
            },
            }}
            >
            <DialogTitle>Entregar ao EP</DialogTitle>
            <DialogContent>
                    <div className='d-flex flex-column pt-4 flex-fill'>
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <span>Técnico Responsável</span>
                                <h6>{tecResp}</h6>
                            </div>
                            <div>
                                <span>Data contratual</span>
                                {(moment(dataContratual, 'DD/MM/YYYY').toDate().getTime() > Date.now()) ? <h6 className='text-success'>{dataContratual}</h6> : <h6 className='text-danger'>{dataContratual}</h6>}
                            </div>
                        </div>

                        <span>Observação técnica:</span>
                        <TextareaAutosize
                            placeholder='Observações'
                            margin="dense"
                            id="input_obs"
                            name="input_obs"
                            label="Aqruivo"
                            variant="standard"
                            className='mb-3 p-1'
                            onChange={handleChangeObs}
                        />
                        <a target='_blank' href={`${props.produto.prod_drive}`}>Link para a pasta do produto</a>
                    </div>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            {!isStatusLoading &&(
                <Button
                    autoFocus
                    margin="dense"
                    id="entregaRevInterna"
                    name="entrega_rev_interna"
                    label="Entrega a Revisao Interna"
                    type="submit"
                    variant="outlined"
                    onClick={entregaRevInterna}
                >Entregar à Revisão Interna</Button>
            )}
            {isStatusLoading &&(
                <Button
                    autoFocus
                    margin="dense"
                    id="entregaRevInterna"
                    name="entrega_rev_interna"
                    label="Entrega a Revisao Interna"
                    type="submit"
                    variant="outlined"
                    disabled
                    endIcon={<Spinner/>}
                >Aguarde</Button>
            )}
            {!isStatusLoading && (
                <Button
                    autoFocus
                    margin="dense"
                    id="entregaGestao"
                    name="entrega_gestao"
                    label="Entrega a gestao"
                    type="submit"
                    variant="outlined"
                    onClick={entregaDiretoGestao}
                >Entregar à gestão</Button>
            )}
            </DialogActions>
            </Dialog>
        </>
    )
}

ModalFormEntregueAoEp.propTypes = {
dataContratual: PropTypes.string,
tecResp: PropTypes.string,
};

const baseStyle = {
  cursor: 'pointer',
  padding: '15px 16px 22px 16px',
  borderWidth: 2,
  borderRadius: 6,
  borderColor: '#ccc',
  borderStyle: 'dashed',
  backgroundColor: '#f8f8f8',
  outline: 'none',
  transition: 'all .24s ease-in-out',
  textAlign: 'center',
}

const activeStyle = {
  borderColor: '#4aa3ff',
  color: '#4aa3ff',
}

const focusStyle = {}

const acceptStyle = {
  borderColor: 'green',
  color: 'green',
}

const rejectStyle = {
  borderColor: 'red',
  color: 'red',
}

export default ModalFormEntregueAoEp;
